<form (ngSubmit)="submitForm()" [formGroup]="registerUserForm">
  <ion-item class="ion-no-padding flex-item">
    <ion-input [formControl]="getControl('email')"
               [label]="('LOGIN.REGISTER_GUEST.DIALOGS.REQUEST_REGISTER.FORM.LABELS.EMAIL' | translate) + (isRequired('email') ? ' *' : '')"
               label-placement="stacked"
               type="email"/>
  </ion-item>
  <div class="form-errors">
    @if (getControl('email').hasError('required')) {
      <ion-text class="ion-native" color="danger">{{ 'TEAM.ISSUES.COMPONENTS.INPUTS.ERRORS.REQUIRED' | translate }}</ion-text>
    }
    @if (getControl('email').hasError('email')) {
      <ion-text class="ion-native" color="danger">{{ 'TEAM.ISSUES.COMPONENTS.INPUTS.ERRORS.VALID_EMAIL' | translate }}</ion-text>
    }
  </div>
  <ion-list>
    <app-shared-show-hide-password>
      <ion-item class="ion-no-padding flex-item">
        <ion-input [label]="('LOGIN.REGISTER_GUEST.DIALOGS.REQUEST_REGISTER.FORM.LABELS.PASSWORD' | translate) + (isRequired('password') ? ' *' : '')"
                   formControlName="password"
                   label-placement="stacked"
                   type="password"/>
      </ion-item>
    </app-shared-show-hide-password>
    <div class="form-errors">
      @if (registerUserForm.get('password')!.invalid) {
        <ion-text class="ion-native" color="danger"
        >
          {{ "LOGIN.FORM-PASSWORD.ERRORS.REQUIREMENTS" | translate }}
        </ion-text>
      }
    </div>
  </ion-list>

  <app-shared-show-hide-password>
    <ion-item class="ion-no-padding flex-item">
      <ion-input [label]="('LOGIN.REGISTER_GUEST.DIALOGS.REQUEST_REGISTER.FORM.LABELS.CONFIRM_PASSWORD' | translate) + (isRequired('confirmPassword') ? ' *' : '')"
                 formControlName="confirmPassword"
                 label-placement="stacked"
                 required="required" type="password"/>
    </ion-item>
  </app-shared-show-hide-password>
  <div class="form-errors">
    @if (registerUserForm.get('confirmPassword')!.hasError('minlength') || registerUserForm.get('confirmPassword')!.hasError('pattern')) {
      <ion-text class="ion-native" color="danger"
      >
        {{ "LOGIN.FORM-PASSWORD.ERRORS.REQUIREMENTS" | translate }}
      </ion-text>
    }
    @if (registerUserForm.touched && registerUserForm.hasError('passwordMismatch')) {
      <ion-text class="ion-native" color="danger"
      >
        {{ "LOGIN.REGISTER_GUEST.DIALOGS.REQUEST_REGISTER.FORM.ERRORS.MISMATCH" | translate }}
      </ion-text>
    }
  </div>
</form>
